import React from "react";
import { FaTimes } from "react-icons/fa";

const RepartitionToolbar = ({ total, selectedCount, onClearSelection }) => {
  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white/80 p-3 shadow-sm backdrop-blur dark:border-white/10 dark:bg-slate-900/80">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-slate-600 dark:text-slate-300">
          Affichés :{" "}
          <span className="font-bold text-slate-950 dark:text-white">
            {total}
          </span>{" "}
          compétiteur{total > 1 ? "s" : ""}
        </p>

        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-orange-50 px-3 py-1 text-sm font-bold text-orange-700 dark:bg-orange-500/10 dark:text-orange-300">
            Sélection : {selectedCount}
          </span>

          {selectedCount > 0 && (
            <button
              type="button"
              onClick={onClearSelection}
              className="inline-flex min-h-9 items-center gap-2 rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-bold text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:text-white dark:hover:bg-white/10"
            >
              <FaTimes className="h-3 w-3" />
              Vider
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RepartitionToolbar;